import { api } from 'api';
import { ENDPOINTS } from 'api/endpoints';
import { TInspirationRoom } from 'app-entities/inspiration-gallery/inspiration-room';

export type TBodyForSearchProjectsRequest = {
  regionId: number;
  showProjectMinPrice: boolean;
  showProjectName: boolean;
  inspirationRooms: TInspirationRoom[];
};

type TProps = {
  body: TBodyForSearchProjectsRequest;
  config?: {
    params: {
      [key: string]: string;
    };
    host: string;
    apiKey?: string;
  };
};

export const fetchProjectsApi = async ({ body, config }: TProps) => {
  const params = new URLSearchParams(config?.params).toString();

  return api.post(`${config?.host}/${ENDPOINTS.projects}?${params}`, JSON.stringify(body), {
    headers: {
      'x-api-key': config?.apiKey,
    },
  });
};
